import React from 'react';

import DynamicStateService, { DynamicStateScopes } from '~features/DynamicStateService';

type ChartDescriptionsState = {
  enabled: boolean;
};

type DynamicStateUserWithChartDescriptions = {
  ChartDescriptions?: ChartDescriptionsState;
};

const INITIAL_CHART_DESCRIPTIONS_STATE: ChartDescriptionsState = {
  enabled: true,
};

function useChartDescriptionsState(): [boolean, (enabled: boolean) => void] {
  const [currentDynamicState, updateDynamicState] =
    DynamicStateService.useDynamicStateService<DynamicStateUserWithChartDescriptions, Record<string, never>>();

  const chartDescriptionsEnabled = React.useMemo(
    () => currentDynamicState?.user?.ChartDescriptions?.enabled ?? INITIAL_CHART_DESCRIPTIONS_STATE.enabled,
    [currentDynamicState?.user?.ChartDescriptions?.enabled]
  );

  const updateChartDescriptionsEnabled = React.useCallback(
    (enabled: boolean) => {
      updateDynamicState({
        scope: DynamicStateScopes.User,
        state: {
          ChartDescriptions: {
            enabled,
          },
        },
      });
    },
    [updateDynamicState]
  );

  return [chartDescriptionsEnabled, updateChartDescriptionsEnabled];
}

export default useChartDescriptionsState;
